import React, { useEffect } from 'react'
import Button from '../components/Button'
import RadioButtonQuestion from '../components/RadioButtonQuestion'
import {questions} from '../data/json'


const TestQuestions6 = ({prevStep, nextStep, handleChange, values}) => {

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
  }, [])

  const postResultsAPI = 'https://modstandsdygtig.azurewebsites.net/api/Report';

  const resultsToPost = {
    answers: [
      {
        value: values.qst1_1,
        questionId: 7
      },
      {
        value: values.qst1_2,
        questionId: 8
      },
      {
        value: values.qst2_1,
        questionId: 40
      },
      {
        value: values.qst2_2,
        questionId: 41
      },
      {
        value: values.qst2_3,
        questionId: 42
      },
      {
        value: values.qst2_4,
        questionId: 43
      },
      {
        value: values.qst3_1,
        questionId: 44
      },
      {
        value: values.qst3_2,
        questionId: 45
      },
      {
        value: values.qst3_3,
        questionId: 46
      },
      {
        value: values.qst3_4,
        questionId: 47
      },
      {
        value: values.qst4_1,
        questionId: 48
      },
      {
        value: values.qst4_2,
        questionId: 49
      },
      {
        value: values.qst4_3,
        questionId: 50
      },
      {
        value: values.qst4_4,
        questionId: 51
      },
      {
        value: values.qst4_5,
        questionId: 52
      },
      {
        value: values.qst5_1,
        questionId: 53
      },
      {
        value: values.qst5_2,
        questionId: 54
      },
      {
        value: values.qst5_3,
        questionId: 55
      },
      {
        value: values.qst5_4,
        questionId: 56
      },
      {
        value: values.qst5_5,
        questionId: 57
      },
      {
        value: values.qst6_1,
        questionId: 58
      },
      {
        value: values.qst6_2,
        questionId: 59
      },
      {
        value: values.qst6_3,
        questionId: 60
      },
      {
        value: values.qst6_4,
        questionId: 61
      },
      {
        value: values.qst6_5,
        questionId: 62
      },
    ]
  }

  const SubmitResult = e => {
    e.preventDefault();
    nextStep();

    let json = JSON.stringify(resultsToPost)

    fetch(postResultsAPI, {
      method: 'POST',
      headers: {
        'Content-Type' : 'application/json'
      },
      body: json
    })
    .then(res => {
      if(res.status === 200) {
        console.log("POST OK")
      } else {
        console.log("POST FAILED")
      }
    })
  }

  const GoBack = e => {
    e.preventDefault(); 
    prevStep();
  }

  return (
    <div className='__test-questions'>
      <h2>Relationer og markedsposition</h2>
      <p>En stærk markedsposition kan sikre en mere stabil indtjening og dermed en mere robust økonomisk situation i jeres virksomhed. Det kan også gøre det lettere at tiltrække nye, og fastholde eksisterende, kunder - selv i vanskelige tider. Endelig kan en stærk markedsposition også give jer større handlefrihed i forhold til at tilpasse jer markedets krav og ændringer. Samlet set kan I bedre navigere i en dynamisk og usikker forretningsverden, og dermed øge jeres modstandsdygtighed. </p>
        <form>
          <RadioButtonQuestion isChecked={values.qst6_1} title={questions.market.qst_1} name="qst-market_1" value={values} onChange={handleChange('qst6_1')}/>
          <RadioButtonQuestion isChecked={values.qst6_2} title={questions.market.qst_2} name="qst-market_2" value={values} onChange={handleChange('qst6_2')}/>
          <RadioButtonQuestion isChecked={values.qst6_3} title={questions.market.qst_3} name="qst-market_3" value={values} onChange={handleChange('qst6_3')}/>
          <RadioButtonQuestion isChecked={values.qst6_4} title={questions.market.qst_4} name="qst-market_4" value={values} onChange={handleChange('qst6_4')}/>
          <RadioButtonQuestion isChecked={values.qst6_5} title={questions.market.qst_5} name="qst-market_5" value={values} onChange={handleChange('qst6_5')}/>
          <div className='__prev-next-buttons'>
            <Button buttonText='Tilbage' onClick={GoBack} />
            <Button buttonText='Næste' onClick={SubmitResult} disabled={(values.qst6_1 !== '' && values.qst6_2 !== '' && values.qst6_3 !== '' && values.qst6_4 !== '' && values.qst6_5 !== '' ) ? false : true} />
          </div>
        </form>
    </div>

  )
}

export default TestQuestions6